<template>
    <div>
       {{ $t("_3ds.processing_payment") }}...
    </div>
</template>

<script>

export default {
    async mounted() {
      // Solo regresamos el postMessage cuando se instancie la pagina y decorle a la principal que puede generar el segudo cobro
      window.parent.postMessage({ message: 'CHALLENGE_COMPLETED' }, '*');
    }
};
</script>

<style></style>
